<div class="popup-inner-space">
    <div style="display: flex; justify-content: space-between; align-items: center;">
        <div>
            Report Configuration - {{this.data.GraphConfigName}}
        </div>
        <div>
            <img src="assets/images/close.svg" alt="Close" style="cursor: pointer; margin-left: auto; height: 24px;"
                (click)="Close()">
        </div>
    </div>

    <mat-tab-group (selectedTabChange)="onTabChange($event)">
        <mat-tab label="Report Shift Timing Settings">
            <form class="width100" [formGroup]="ReportTimingForm">
                <div class="container-data56 popup-inner-space mb-5">
                    <div class="errmsg error-fix" *ngIf="errorMsg">{{errorMsg}}</div>
                    <div class="sucessmsg  error-fix" *ngIf="successMsg">{{successMsg}}</div>
                </div>
                <div class="row marginleftright0 ">
                    <div class="col-sm-3 col-md-3 col-lg-3 mb-2 padding-left-10 padding-right-0">
                        <div class="fxg-field fxg-field2">
                            <input formControlName="GraphConfigName" id="GraphConfigName" type="text"
                                class="fxg-field__input-text fxg-field__input--required sessioncamexclude">
                            <span class="fxg-field__placeholder fxg-field__floating-placeholder custom-placeholder"
                                tabindex="-1">Shift Name</span>
                            <div class="error_msg" *ngIf="displayMessage.GraphConfigName">
                                {{displayMessage.GraphConfigName}}
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 paddingleftright5">
                        <div class="fxg-field fxg-field2">
                            <mat-form-field style="display:block;" title="Data Type">
                                <mat-select formControlName="TimeDuration"
                                    (selectionChange)="OnChangeTimeDuration($event.value)">
                                    <mat-option value="" MatFormFieldControl="TimeDuration">(Select Time
                                        Duration)</mat-option>
                                    <mat-option value="Hourly">Hourly</mat-option>
                                    <mat-option value="Daily">Daily</mat-option>
                                    <mat-option value="Weekly">Weekly</mat-option>
                                    <mat-option value="Monthly">Monthly</mat-option>
                                    <mat-option value="Yearly">Yearly</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <span class="error_msg"
                                *ngIf="displayMessage.TimeDuration">{{displayMessage.TimeDuration}}</span>
                        </div>
                    </div>
                    <mat-form-field style="width:85px;" class="timepicker margin-right-5" appearance="fill">
                        <mat-label>From Time</mat-label>
                        <input matTimepicker #t1="matTimepicker" [strict]="false" id="timepicker-example" mode="24h"
                            formControlName="FromTime" placeholder="Please select time..." name="FromTime"
                            (timeChange)="timeChangeHandler($event, 'FromTime')">
                    </mat-form-field>
                    <mat-form-field style="width:85px;" class="timepicker margin-right-5" appearance="fill">
                        <mat-label>To Time</mat-label>
                        <input matTimepicker #t2="matTimepicker" [strict]="false" id="timepicker-example" mode="24h"
                            formControlName="ToTime" placeholder="Please select time..." name="ToTime"
                            (timeChange)="timeChangeHandler($event, 'ToTime')">
                    </mat-form-field>
                    <div *ngIf="selectedtimeduration=='Daily'">

                        <mat-form-field style="width:85px" class="timepicker margin-right-5" appearance="fill">
                            <mat-label>Time Interval</mat-label>
                            <input matTimepicker #t="matTimepicker" [strict]="false" id="timepicker-example" mode="24h"
                                formControlName="Interval" placeholder="Please select time..." name="Interval"
                                (timeChange)="timeChangeHandler($event, 'Interval')">
                        </mat-form-field>
                    </div>


                    <div class="col-lg-3 paddingleftright5" *ngIf="selectedtimeduration=='Daily'">
                        <div class="fxg-field fxg-field2">
                            <mat-form-field style="display:block;" title="Day Span">
                                <mat-select formControlName="DaySpan" (selectionChange)="OnChangeDaySpan($event)">

                                    <mat-option selected MatFormFieldControl="DaySpan" value="">(Select
                                        Day Span)</mat-option>
                                    <mat-option value="0">Today</mat-option>
                                    <mat-option value="1">1 Day</mat-option>
                                    <mat-option value="2">2 Day</mat-option>
                                    <mat-option value="3">3 Day</mat-option>
                                    <mat-option value="4">4 Day</mat-option>
                                    <mat-option value="5">5 Day</mat-option>
                                    <mat-option value="6">6 Day</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <!-- <span class="error_msg" *ngIf="displayMessage.DaySpan">{{displayMessage.DaySpan}}</span> -->
                        </div>
                    </div>

                    <div class="col-lg-3 paddingleftright15 d-flex">
                        <button class="btncommon search-usermater" id="SearchusermasterSearch"
                            (click)="AddRegisters()">Add</button>
                    </div>
                </div>
                <div class="table-scroll-newsite tableBR margin-left-5">
                    <table class="table table-layout-fixed">
                        <thead class="companytable thead-data td-data-main">
                            <tr class="tr-padding">
                                <th class="width-10">No.</th>
                                <th class="width-25">Report Name</th>
                                <th class="width-25">From Time</th>
                                <th class="width-25">To Time</th>
                                <th class="width-25">Interval</th>
                                <th class="width-25">Time Duration</th>
                                <th class="width-25">Day Span</th>
                                <th class="width10 text-right">Action</th>
                            </tr>
                        </thead>
                        <tbody class="table-responsive-sechedule">
                            <tr *ngFor="let data of GraphConfigList; let i = index">
                                <td class="width-10">{{i+1}}</td>
                                <td class="width-25">{{data.GraphConfigName}}</td>
                                <th class="width-25">{{data.FromTime}}</th>
                                <th class="width-25">{{data.ToTime}}</th>
                                <td class="width-25">{{data.Interval}}</td>
                                <td class="width-25">{{data.TimeDuration}}</td>
                                <td class="width-25">{{data.DaySpan}}</td>
                                <td class="width10 text-right"><img src="assets/images/delete.svg" alt="..."
                                        class="img-fluid closeicon2 cursor-pointer" (click)="DeleteGraphConfigData(i)"
                                        id="delete_icon">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="row marginleftright0 margin-top-5 d-flex justify-content-end margin-left-15">
                    <div class="col-lg-3 paddingleftright5 text-right padding-right-15 margin-left-15">
                        <button type="submit" class="btncommon search-usermater"
                            id="SearchusermasterSearch margin-left-15" (click)="SaveParameterConfigData()">Save</button>
                    </div>
                </div>
            </form>

        </mat-tab>


        <mat-tab label="Email Scheduling Settings">
            <form class="width100 mt-5" [formGroup]="EmailTimingForm">
                <div class="container-data56 popup-inner-space mt-3">
                    <div class="errmsg error-fix" *ngIf="errorMsg1">{{errorMsg1}}</div>
                    <div class="sucessmsg  error-fix" *ngIf="successMsg1">{{successMsg1}}</div>
                </div>
                <div class="row marginleftright0">

                    <div class="col-lg-3 paddingleftright5">
                        <div class="fxg-field fxg-field2">
                            <mat-form-field style="display:block;" title="Report Timing">
                                <mat-select formControlName="ReportTiming"
                                    (selectionChange)="OnChangeReportTiming($event)">
                                    <mat-option selected value="" MatFormFieldControl="ReportTiming">(Select
                                        Report Timing)</mat-option>

                                    <mat-option *ngFor="let lstsite of GraphConfigList" [value]="lstsite">
                                        {{ lstsite.GraphConfigName }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <span class="error_msg"
                                *ngIf="displayMessage.ReportTiming">{{displayMessage.ReportTiming}}</span>
                        </div>
                    </div>
                    <div class="col-lg-3 paddingleftright5">
                        <div class="fxg-field fxg-field2">
                            <mat-form-field style="display:block;" title="Schedule Type">
                                <mat-select formControlName="ScheduleType"
                                    (selectionChange)="OnChangeScheduleType($event)">

                                    <mat-option selected value="" MatFormFieldControl="ScheduleType">(Select
                                        Schedule Type)</mat-option>
                                    <mat-option value="Daily">Daily</mat-option>
                                    <mat-option value="Weekly">Weekly</mat-option>
                                    <mat-option value="Monthly">Monthly</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <span class="error_msg"
                                *ngIf="displayMessage.ScheduleType">{{displayMessage.ScheduleType}}</span>
                        </div>
                    </div>

                    <div class="fxg-field margin-right-5 cust_input_date_time" style="width: 10%; ">
                        <mat-form-field class="calendar font13" appearance="fill">
                            <mat-label><span style="margin-left: 0px; margin-top: 0px">Email Time</span></mat-label>
                            <input style="margin-left: 0px; font-size: 13px;" matTimepicker #t="matTimepicker"
                                id="timepicker-example" mode="24h" formControlName="EmailTime"
                                placeholder="Please select time..." name="EmailTime" type="text" required
                                (timeChange)="timeChangeHandler($event, 'EmailTime')">

                        </mat-form-field>
                        <div style="position: relative;">
                            <span class="error_msg" *ngIf="displayMessage.EmailTime">{{displayMessage.EmailTime}}</span>
                        </div>
                    </div>

                    <div class="col-lg-3 paddingleftright5" *ngIf="dayspanflag==true">
                        <div class="fxg-field fxg-field2">
                            <mat-form-field style="display:block;" title="Day Span">
                                <mat-select formControlName="DaySpan" (selectionChange)="OnChangeDaySpan($event)">

                                    <mat-option selected MatFormFieldControl="DaySpan" value="">(Select
                                        Day Span)</mat-option>
                                    <mat-option value="0">Today</mat-option>
                                    <mat-option value="1">1 Day</mat-option>
                                    <mat-option value="2">2 Day</mat-option>
                                    <mat-option value="3">3 Day</mat-option>
                                    <mat-option value="4">4 Day</mat-option>
                                    <mat-option value="5">5 Day</mat-option>
                                    <mat-option value="6">6 Day</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <span class="error_msg" *ngIf="displayMessage.DaySpan">{{displayMessage.DaySpan}}</span>
                        </div>
                    </div>

                    <div class="col-lg-3 paddingleftright5" *ngIf="emaildayflag==true">
                        <div class="fxg-field fxg-field2">
                            <mat-form-field style="display:block;" title="Data Type">
                                <mat-select formControlName="EmailDay" (selectionChange)="OnChangeEmailDay($event)">
                                    <mat-option value="selection" MatFormFieldControl="EmailDay">(Select
                                        Email Day)</mat-option>
                                    <mat-option value="Sunday">Sunday</mat-option>
                                    <mat-option value="Monday">Monday</mat-option>
                                    <mat-option value="Tuesday">Tuesday</mat-option>
                                    <mat-option value="Wednesday">Wednesday</mat-option>
                                    <mat-option value="Thursday">Thursday</mat-option>
                                    <mat-option value="Friday">Friday</mat-option>
                                    <mat-option value="Saturday">Saturday</mat-option>

                                </mat-select>
                            </mat-form-field>
                            <span class="error_msg" *ngIf="displayMessage.EmailDay">{{displayMessage.EmailDay}}</span>
                        </div>
                    </div>


                    <div class="col-lg-3 paddingleftright5" *ngIf="emaildateflag == true">
                        <div class="fxg-field fxg-field2">
                            <mat-form-field style="display: block;" title="Day Span">
                                <mat-select formControlName="EmailDate" (selectionChange)="OnChangeEmailDate($event)">
                                    <mat-option value="" MatFormFieldControl="EmailDate">(Select Email
                                        Date)</mat-option>
                                    <mat-option *ngFor="let day of dateOptions" [value]="day">{{ day }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <span class="error_msg" *ngIf="displayMessage.EmailDate">{{ displayMessage.EmailDate
                                }}</span>
                        </div>
                    </div>


                    <div class="col-sm-3 col-md-3 col-lg-9 mb-2 padding-left-10 padding-right-0">
                        <div class="fxg-field fxg-field2">
                            <input formControlName="EmailIds" id="EmailIds" type="text"
                                class="fxg-field__input-text fxg-field__input--required sessioncamexclude">
                            <span class="fxg-field__placeholder fxg-field__floating-placeholder custom-placeholder"
                                tabindex="-1">Email Ids</span>
                            <div class="error_msg" *ngIf="displayMessage.EmailIds">
                                {{displayMessage.EmailIds}}
                            </div>
                        </div>
                    </div>


                    <div class="col-lg-3 paddingleftright15 d-flex">
                        <button class="btncommon search-usermater" id="SearchusermasterSearch"
                            (click)="AddEmailData()">Add</button>
                    </div>
                </div>
                <div class="table-scroll-newsite tableBR margin-left-5">
                    <table class="table table-layout-fixed">
                        <thead class="companytable thead-data td-data-main">
                            <tr class="tr-padding">
                                <th class="width-5">No.</th>
                                <th class="width-25">Report Timing</th>
                                <th class="width-25">Schedule Type</th>
                                <th class="width-25">Day Span</th>
                                <th class="width-25">Email Time</th>
                                <th class="width-25">Email Day</th>
                                <th class="width-25">Email Date</th>
                                <th class="width-25">Email Ids</th>
                                <th class="width10 text-right">Action</th>
                            </tr>
                        </thead>
                        <tbody class="table-responsive-sechedule">
                            <tr *ngFor="let data of EmailConfigList; let i = index">
                                <td class="width-5">{{i+1}}</td>
                                <td class="width-25"
                                    style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 150px;"
                                    [title]="data.ReportShiftName">{{data.ReportShiftName}}</td>
                                <th class="width-25">{{data.ScheduleType}}</th>
                                <th class="width-25">{{data.DaySpan}}</th>
                                <td class="width-25">{{data.EmailTime}}</td>
                                <td class="width-25">{{data.EmailDay}}</td>
                                <td class="width-25">{{data.EmailDate}}</td>
                                <td class="width-25"
                                    style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 150px;"
                                    [title]="data.EmailIds">
                                    {{data.EmailIds}}
                                </td>
                                <td class="width10 text-right">
                                    <img src="assets/images/delete.svg" alt="..."
                                        class="img-fluid closeicon2 cursor-pointer"
                                        (click)="DeleteCustomEmailConfigData(i)" id="delete_icon">
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
                <div class="row marginleftright0 margin-top-5 d-flex justify-content-end">
                    <div class="col-lg-3 paddingleftright5 text-right padding-right-15">
                        <button type="submit" class="btncommon search-usermater" id="SearchusermasterSearch"
                            (click)="SaveEmailConfigData()">Save</button>
                    </div>
                </div>
            </form>
        </mat-tab>

    </mat-tab-group>

</div>